import React, { FunctionComponent } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { financialItemStyles } from "./styles/financialItemStyle";
import { Grid, Typography } from "@material-ui/core";
import "../Print.css";

type DepartmentDataProps = {
  departmentData: Array<object>;
  departmentTotal: string;
  source: string;
};
export const DepartmentSummary: FunctionComponent<DepartmentDataProps> = ({
  departmentData,
  departmentTotal,
  source,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>
                Department Summary
              </Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "50%" }}
                ></TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {departmentData &&
                departmentData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.headColor}>
                      {data.name}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.DepartmentCount ? data.DepartmentCount : "0"}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.float_departmentTotal
                        ? data.float_departmentTotal
                        : "0.00"}
                    </TableCell>
                  </TableRow>
                ))}

              <TableRow>
                <TableCell align="left" className={classes.headCell}>
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headColor}
                ></TableCell>
                <TableCell align="right" className={classes.headCell}>
                  {departmentTotal ? departmentTotal : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
